/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteDocuments_QuoteDocumentFragment = { __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } };

export type QuoteDocuments_QuoteFragment = { __typename: 'Quote', id: string, viewerPermissions: Array<Types.PermissionName>, documents: Array<{ __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } }> };

export type GenerateQuoteDocumentPdfMutationVariables = Types.Exact<{
  input: Types.GenerateQuotePdfInput;
}>;


export type GenerateQuoteDocumentPdfMutation = { generateQuotePdf: { __typename: 'GenerateQuotePdfResult', url: string, quoteDocument?: { __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } } | null } };

export type RequestQuoteDocumentUploadMutationVariables = Types.Exact<{
  input: Types.RequestQuoteDocumentUploadInput;
}>;


export type RequestQuoteDocumentUploadMutation = { requestQuoteDocumentUpload: { __typename: 'RequestQuoteDocumentUploadResult', uploadUrl: string, uploadKey: string } };

export type AddQuoteDocumentMutationVariables = Types.Exact<{
  input: Types.AddQuoteDocumentInput;
}>;


export type AddQuoteDocumentMutation = { addQuoteDocument: { __typename: 'AddQuoteDocumentResult', quoteDocument: { __typename: 'QuoteDocument', id: string, name: string, source: Types.QuoteDocumentSource, calculationType?: Types.QuotePdfCalculationType | null, createdAt: any, createdBy: { __typename: 'User', id: string, firstname: string, familyname: string }, file: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, group: string, url: string } } } };

export const QuoteDocuments_QuoteDocumentFragmentDoc = gql`
    fragment QuoteDocuments_QuoteDocument on QuoteDocument {
  id
  name
  source
  calculationType
  createdAt
  createdBy {
    id
    firstname
    familyname
  }
  file {
    id
    title
    mimeType
    group
    url
  }
}
    `;
export const QuoteDocuments_QuoteFragmentDoc = gql`
    fragment QuoteDocuments_Quote on Quote {
  id
  viewerPermissions
  documents {
    ...QuoteDocuments_QuoteDocument
  }
}
    ${QuoteDocuments_QuoteDocumentFragmentDoc}`;
export const GenerateQuoteDocumentPdfDocument = gql`
    mutation GenerateQuoteDocumentPdf($input: GenerateQuotePdfInput!) {
  generateQuotePdf(input: $input) {
    url
    quoteDocument {
      ...QuoteDocuments_QuoteDocument
    }
  }
}
    ${QuoteDocuments_QuoteDocumentFragmentDoc}`;
export type GenerateQuoteDocumentPdfMutationFn = Apollo.MutationFunction<GenerateQuoteDocumentPdfMutation, GenerateQuoteDocumentPdfMutationVariables>;

/**
 * __useGenerateQuoteDocumentPdfMutation__
 *
 * To run a mutation, you first call `useGenerateQuoteDocumentPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuoteDocumentPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuoteDocumentPdfMutation, { data, loading, error }] = useGenerateQuoteDocumentPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQuoteDocumentPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQuoteDocumentPdfMutation, GenerateQuoteDocumentPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQuoteDocumentPdfMutation, GenerateQuoteDocumentPdfMutationVariables>(GenerateQuoteDocumentPdfDocument, options);
      }
export type GenerateQuoteDocumentPdfMutationHookResult = ReturnType<typeof useGenerateQuoteDocumentPdfMutation>;
export type GenerateQuoteDocumentPdfMutationResult = Apollo.MutationResult<GenerateQuoteDocumentPdfMutation>;
export type GenerateQuoteDocumentPdfMutationOptions = Apollo.BaseMutationOptions<GenerateQuoteDocumentPdfMutation, GenerateQuoteDocumentPdfMutationVariables>;
export const RequestQuoteDocumentUploadDocument = gql`
    mutation RequestQuoteDocumentUpload($input: RequestQuoteDocumentUploadInput!) {
  requestQuoteDocumentUpload(input: $input) {
    uploadUrl
    uploadKey
  }
}
    `;
export type RequestQuoteDocumentUploadMutationFn = Apollo.MutationFunction<RequestQuoteDocumentUploadMutation, RequestQuoteDocumentUploadMutationVariables>;

/**
 * __useRequestQuoteDocumentUploadMutation__
 *
 * To run a mutation, you first call `useRequestQuoteDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestQuoteDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestQuoteDocumentUploadMutation, { data, loading, error }] = useRequestQuoteDocumentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestQuoteDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<RequestQuoteDocumentUploadMutation, RequestQuoteDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestQuoteDocumentUploadMutation, RequestQuoteDocumentUploadMutationVariables>(RequestQuoteDocumentUploadDocument, options);
      }
export type RequestQuoteDocumentUploadMutationHookResult = ReturnType<typeof useRequestQuoteDocumentUploadMutation>;
export type RequestQuoteDocumentUploadMutationResult = Apollo.MutationResult<RequestQuoteDocumentUploadMutation>;
export type RequestQuoteDocumentUploadMutationOptions = Apollo.BaseMutationOptions<RequestQuoteDocumentUploadMutation, RequestQuoteDocumentUploadMutationVariables>;
export const AddQuoteDocumentDocument = gql`
    mutation AddQuoteDocument($input: AddQuoteDocumentInput!) {
  addQuoteDocument(input: $input) {
    quoteDocument {
      ...QuoteDocuments_QuoteDocument
    }
  }
}
    ${QuoteDocuments_QuoteDocumentFragmentDoc}`;
export type AddQuoteDocumentMutationFn = Apollo.MutationFunction<AddQuoteDocumentMutation, AddQuoteDocumentMutationVariables>;

/**
 * __useAddQuoteDocumentMutation__
 *
 * To run a mutation, you first call `useAddQuoteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuoteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuoteDocumentMutation, { data, loading, error }] = useAddQuoteDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuoteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddQuoteDocumentMutation, AddQuoteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuoteDocumentMutation, AddQuoteDocumentMutationVariables>(AddQuoteDocumentDocument, options);
      }
export type AddQuoteDocumentMutationHookResult = ReturnType<typeof useAddQuoteDocumentMutation>;
export type AddQuoteDocumentMutationResult = Apollo.MutationResult<AddQuoteDocumentMutation>;
export type AddQuoteDocumentMutationOptions = Apollo.BaseMutationOptions<AddQuoteDocumentMutation, AddQuoteDocumentMutationVariables>;